 <template>
    <v-container fluid>
        <v-card>
          <v-toolbar>
            <v-icon>phone_forwarded</v-icon>
            <v-toolbar-title class="font-weight-light">&nbsp;Gestión Telefónica</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn text icon color="red" v-on="on" @click="setStatusTareaFrecuente(action)">
                  <v-icon v-if="action.esFrecuente">favorite</v-icon>
                  <v-icon v-else>favorite_border</v-icon>
                </v-btn>
              </template>
              <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>  
              <span v-else>Agregar a Tareas Frecuentes</span>  
            </v-tooltip>
          </v-toolbar>
          <v-card-text>
            <v-row>
                <v-col cols ="3">
                    <v-autocomplete v-model="filtro.empresaId" :items="empresas" autocomplete="disabled"
                        item-text="nombre" item-value="id" label="Casos de la Empresa" placeholder="Seleccione una" :menu-props="{minWidth:'400'}"></v-autocomplete>
                </v-col>
                <v-col cols="2">
                    <v-radio-group v-model="filtro.soloCasosPropios" column :mandatory="true">
                        <v-radio :value='true' label="Asignados A Mi"></v-radio>
                        <v-radio :value='false' label="Asignados A Otro"></v-radio>
                    </v-radio-group>
                </v-col>
                <v-col cols="3">
                      <v-autocomplete v-if="!filtro.soloCasosPropios" v-model="filtro.asignadoA" :items="listGestores"
                          item-text="login" item-value="login" label="Gestor:" placeholder="Seleccione uno"></v-autocomplete>
                </v-col>
                <v-col cols="3">
                    <v-radio-group v-model="filtro.soloPromesaVencida" column :mandatory="true">
                        <v-radio :value='false' label="Ver Todos"></v-radio>
                        <v-radio :value='true' label="Sólo con Promesa Vencida"></v-radio>
                    </v-radio-group>
                </v-col>
            </v-row>
            <v-row align="center">
                <v-col cols="3">
                    <v-checkbox v-model="filtro.soloMontosAltos" label="Sólo Montos Altos">
                      <template v-slot:append>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on">info</v-icon>
                          </template>
                            <template>
                              <p>
                              Sólo traerá casos con Capital Total > $30000
                              </p>
                            </template>
                        </v-tooltip>
                      </template>
                    </v-checkbox>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="3">
                    <v-text-field v-model="filtro.cui" label="Buscar por documento/cuil"></v-text-field>
                </v-col>
                
                <v-col cols="2">
                    <v-btn color="success" @click="getItems(true)">Traer Casos</v-btn>
                </v-col>
            </v-row>
            
            <v-flex>
                <v-card >
                  <v-toolbar dense :color="$store.state.UiColors.crudToolbarList">
                    <v-icon>list</v-icon>
                    <v-toolbar-title class="font-weight-light">Casos Asignados</v-toolbar-title>
                    <v-spacer></v-spacer>                      
                  </v-toolbar>
                
                  <v-data-table dense
                    :headers="headers"
                    :items="records"
                    :server-items-length="totalItems"
                    :rows-per-page="pagination.rowsPerPage"                      
                    :options.sync ="pagination"
                    v-model="selectedRow"
                    :loading="loading"                      
                    :footer-props="footer" 
                    item-key="id"                    
                  >
                  <template v-slot:item="{item}">
                      <tr @click="getDetalleCaso(item)" v-bind:class="[(selectedRow[0] && (selectedRow[0].personaId == item.personaId)) ? 'grey lighten-2': 'white']">
                        <!-- <td><v-simple-checkbox class="caption" color="green" :value="isSelected" @input="select($event)"></v-simple-checkbox></td> -->
                        <td><app-acciones-comunes :documento="item.cui.toString().substring(2, 10)" > </app-acciones-comunes></td>

                        <td class="text-xs-left caption" >{{ item.vectorAtraso }}</td>
                        <td class="text-xs-left caption">{{ item.nombreCliente }}</td>
                        <td class="text-xs-left caption"> 
                          <span v-if="item.fechaUltimoPago">{{ item.fechaUltimoPago | dateParse('YYYY-MM-DD') | dateFormat('DD-MM-YYYY')}} </span>
                          <span v-else>-</span>
                        </td>
                        <td class="text-xs-left caption">{{ item.capitalTotal | currency }}</td>
                        <td class="text-xs-left caption">{{ item.deuda | currency }}</td>
                        <td class="text-xs-left caption">{{ item.importeCuota | currency }}</td>
                        <td class="text-xs-left caption">{{ item.creditosEnMora }}</td>
                        <td class="text-xs-left caption">{{ item.ultimaRespuesta}}</td>
                        <td class="text-xs-left caption"> 
                          <span v-if="item.fechaRespuesta">{{ item.fechaRespuesta | dateParse('YYYY-MM-DD') | dateFormat('DD-MM-YYYY')}} </span>
                          <span v-else>-</span>
                        </td>
                        <td class="text-xs-left caption">{{ item.primerVtoImpago | dateParse() | dateFormat('DD-MM-YYYY')}}</td>
                        <td class="text-xs-left caption"> 
                          <span v-if="item.fechaUltimaPromesa">{{ item.fechaUltimaPromesa | dateParse('YYYY-MM-DD') | dateFormat('DD-MM-YYYY')}} </span>
                          <span v-else>-</span>
                        </td>
                        <td class="text-xs-left caption">{{ item.asignadoA}}</td>
                        <td class="text-xs-left caption">{{ item.fechaGestion | dateParse() | dateFormat('DD-MM-YYYY')}}</td>
                        <td class="text-xs-left caption"><v-chip small :color="item.empresaColor" label dark>{{item.empresaShort}}</v-chip></td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card >
            </v-flex>
            
            <v-row>
              <p></p>
            </v-row>

            <v-flex>
                <v-card v-if="showDetalle">
                  <v-card-title>
                    <v-toolbar color="green" dark>
                      <v-icon>phone_forwarded</v-icon>
                      <v-toolbar-title class="font-weight-light">&nbsp;Gestionando a {{selectedPersona.apellido + ' ' + selectedPersona.nombre + ' D.N.I. ' + selectedPersona.documento}}</v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-chip :color="selectedRow[0].empresaColor" label dark>{{selectedRow[0].empresaNombre}}</v-chip>
                    </v-toolbar>
                  </v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col cols="6">
                        <!-- TABLA CREDITOS EN MORA -->
                        <creditos-mora-persona :personaId="selectedPersona.id"
                                              v-on:loading-changed="loadingCreditosEnMora = $event"> </creditos-mora-persona>
                      </v-col>

                      <v-col cols="6">
                        <!-- TABLA TELEFONOS -->
                        <!-- <telefonos-persona-gestion :personaId="selectedPersonaId" :tareaId="selectedTareaAsignadaId"
                                                    v-on:loading-changed="loadingTelefonos = $event"> </telefonos-persona-gestion> -->
                        <app-manejo-telefonos propName = "telefonos" :value="selectedPersona.datosContacto" :modoGestion="true"
                                              v-on:update-telefonos="updateTelefonos" 
                                              v-on:generar-contacto="generarContacto($event)"></app-manejo-telefonos>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="6">
                        <!-- HISTORIAL DE LLAMADAS -->
                        <gestiones-telefonicas-persona :personaId="selectedPersona.id" v-on:loading-changed="loadingGestionesTelefonicas = $event"> </gestiones-telefonicas-persona>
                      </v-col>

                      <v-col cols="6">
                        <!-- OTRAS GESTIONES -->
                        <gestiones-persona :personaId="selectedPersona.id" v-on:loading-changed="loadingOtrasGestiones = $event"> </gestiones-persona>
                      </v-col>

                    </v-row>
                  </v-card-text>
                </v-card>
            </v-flex>

            <v-divider></v-divider>
          </v-card-text>
          <v-card-actions>
            
          </v-card-actions>
        </v-card >

        <!-- Ver Legajo Cliente  -->
        <v-dialog v-model="showLegajoPersona" width="1000" >
            <legajo-persona :personaId="selectedPersonaId"> </legajo-persona>
        </v-dialog>

        <!-- Ver Legajo Virtual  -->
        <v-dialog v-model="showLegajoVirtual" persistent width="700">
            <legajo-virtual :personaId="selectedPersonaId" @close-dialog="showLegajoVirtual=false"> </legajo-virtual>
        </v-dialog>

        <app-loading :loading="componentsLoading"></app-loading>

        <template v-if="$store.state.debugModeOn">
          Debug Info: <p></p>
          
          Model: {{filtro}}  <p></p>                            
        </template>
    </v-container>
      
</template>

<script>

import { http } from '@/axios'
import Vue from 'vue'
import {
  //mapState,
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'

import CreditosEnMoraPersona from '@/components/common/ListaCreditosEnMoraPorPersona.vue'
import ListaGestionesPersona from '@/components/gestion/ListaGestionesPersona.vue'
import ListaGestionesTelefonicasPersona from '@/components/gestion/ListaGestionesTelefonicasPersona.vue'
import { ref } from 'vue'

 

export default {
    components: {
    'creditos-mora-persona':CreditosEnMoraPersona,
    'gestiones-persona':ListaGestionesPersona,
    'gestiones-telefonicas-persona':ListaGestionesTelefonicasPersona
  },
  data() {
    return {
      primeraBusquedaRealizada:false,
      loading: false,
      loadingCreditosEnMora:false,
      loadingTelefonos:false,
      loadingGestionesTelefonicas:false,
      loadingOtrasGestiones:false,
      suspend: false,
      filterChanged:false,
      search: '', // valor para búsqueda
      pagination: { // definición de paginación
        sortDesc:[true],
        sortBy:[''],
        page: 1,
        itemsPerPage: 5
      },
      footer:{        
        showFirstLastPage: true,
        itemsPerPageOptions:[5,10,20, 50]
      },
      totalItems: 0, // va afuera de pagination 
      headers: [ // definición de columnas
        { text: 'Ver', value: 'accion', width:80, sortable:false },
        { text: 'V.A.', value: 'vectorAtraso',width:80,},
        { text: 'Nombre', value: 'nombreCliente'},
        { text: 'Último Pago', value: 'fechaUltimoPago',width: 130},
        { text: 'Capital Total', value: 'capitalTotal',width: 130},
        { text: 'Deuda Vencida', value: 'deuda',width: 130},
        { text: '$ Cuota', value: 'importeCuota',width: 130},
        { text: '# Créd. en Mora', value: 'creditosEnMora'},
        { text: 'Última Rta.', value: 'ultimaRespuesta', width: 130},
        { text: 'Fecha Rta.', value: 'fechaRespuesta', width: 130},
        { text: '1er Vto. Impago', value: 'primerVtoImpago', width: 130},
        { text: 'Promesa', value: 'fechaUltimaPromesa'},
        { text: 'Asignado A', value: 'asignadoA', width:100},
        { text: 'Gestionar el', value: 'fechaGestion', width:100},
        { text: 'Empresa', value: 'empresa', width:100},
      ],
      records: [], // registros
      selectedRow: [],
      filtro: {empresaId:0, soloCasosPropios:true, soloPromesaVencida:false, soloMontosAltos: false},
      selectedCaso: {creditosEnMora:[],telefonos:[],otrasGestiones:[]},
      empresas: [],
      listGestores:[],
      showDetalle: false,
      showLegajoPersona: false,
      showLegajoVirtual: false,
      selectedPersonaId: '',
      selectedTareaAsignadaId:'',
      selectedPersonaDocumento: '',
      selectedPersona:{}
    };
  },
  async created() {   
      this.loadEmpresas();
      this.loadGestores();
  },  
  watch: {
    pagination :{
        handler(){
          if(this.primeraBusquedaRealizada)
            this.getItems(false);
        },
        deep: true
    },
    search() {
        this.getItems(true);
    },
    'activeTask':function(){
      //closeRelatedTasks es una variable del state que la pongo en true cuando se cierra el coso de activeTask y quiero cerrar otras cosas relacionadas
      if(this.closeRelatedTasks)
      {
          this.showDetalle = false;
          this.getItems(false);
      }
    }
  },
  computed: {
    ...mapGetters(['activeTask','getActionFromLink','user','closeRelatedTasks']),
    action: function(){
      return this.getActionFromLink(this.$route.path) 
    },
    componentsLoading: function(){
      return this.loadingCreditosEnMora || this.loadingTelefonos || this.loadingGestionesTelefonicas || this.loadingOtrasGestiones;
    }
  },
  methods: {
    ...mapMutations(["setActiveTask","alertClear", "alertSuccess", "alertWarning", "alertError"]),
    ...mapActions(['setStatusTareaFrecuente']),    
    async getItems(resetPagination) {
      //Hago esto para que si cambias los filtros y tocas consultar traiga los resultados de la primera página
      if(resetPagination)
      {
        this.pagination.page = 1
      }

      this.loading = true
      this.$validator.reset()
      
      let filter = this.filtro;

      //Si se eligió TODOS armo un string con todos los canales de venta habilitados para el usuario.
      /*if(filter.empresaId === 0)
      {
        filter.empresaId = this.empresas.map(e => e.id).join(",");
        Vue.$log.debug(filter.empresaId);
      }*/

      filter.asignadoA = filter.soloCasosPropios ? this.user.login : (filter.asignadoA == '(Todos)' ? '' : filter.asignadoA);
      filter.cui = filter.cui ? filter.cui : 0;
 
      try {
        var result = await http.get('gestion/getcasosporgestor?empresaId='+filter.empresaId + '&gestor=' + filter.asignadoA
                                    + '&soloPromesaVencida='+filter.soloPromesaVencida + '&soloMontosAltos='+filter.soloMontosAltos
                                    + '&cuil=' + filter.cui
                                    + '&limit='+this.pagination.itemsPerPage+'&page='+this.pagination.page 
                                    + '&sortby='+this.pagination.sortBy+'&descending='+(this.pagination.sortDesc.length > 0 ? this.pagination.sortDesc : 'false') );
        
        this.records = result.list;
        
        this.totalItems = result.totalCount
      } catch (error) {
        // Error
        this.alertError(error)
      }
      this.primeraBusquedaRealizada = true
      this.loading = false
    },
    async getDetalleCaso(caso){
      this.selectedPersonaId = caso.personaId;
      //hago esto para que no busque el detalle cuando se toca para ver los legajos. los cosos se buscan cuando se hace el loadPersona
      if(this.showLegajoPersona || this.showLegajoVirtual)
        return;

      this.selectedRow[0] = caso;
      
      this.selectedTareaAsignadaId = caso.tareaId;
      this.loadPersona(caso.personaId);
      
      this.showDetalle = true;
    },
    async loadPersona(personaId) {
        this.loading = true
        try {
            var result = await http.get('personas/' + personaId);
            
            this.selectedPersona = result;

            // trato las fechas
            var dob = this.$moment(this.selectedPersona.fechaNacimiento).format('YYYY-MM-DD')
            this.selectedPersona.fechaNacimiento = dob;

            if(this.selectedPersona.empleo != null){
              var fi = this.$moment(this.selectedPersona.empleo.fechaIngreso).format('YYYY-MM-DD');
              this.selectedPersona.empleo.fechaIngreso = fi;
            }

        } catch (error) {
            // Error
            this.alertError(error)
        }
        this.loading = false
    },
    async verLegajo(item){
      this.selectedPersonaId = item.personaId;
      this.showLegajoPersona = true;
    },
    async verLegajoVirtual(item){
      this.selectedPersonaId = item.personaId;
      this.selectedPersonaDocumento = item.documento.toString();
      this.showLegajoVirtual = true;
    },
    async loadEmpresas(){
      this.loading = true;
      try{
        var result = await http.get('empresas/list/porusuario?usuarioId='+this.user.id);

        this.empresas = result.list;
        this.empresas.unshift({id:0,nombre:'(Todas)'});
      }
      catch(error){
        // Error
        this.alertError(error)
      }
      this.loading = false;
    },
    async loadGestores(){
      this.loading = true;
      try{
        var result = await http.get('usuarios/listByRol?rolId=4');//traigo los usuarios con rol gestor

        this.listGestores = result.list;
        this.listGestores.unshift({id:"00000000-0000-0000-0000-000000000000",login:'(Todos)'});
      }
      catch(error){
        // Error
        this.alertError(error)
      }
      this.loading = false;
    },
    async updateTelefonos(){
      //guardo la persona entera para actualizar los telefonos
      try{          
          this.loading = true;
          var result = await http.put('personas', JSON.stringify( {persona:  this.selectedPersona} ) );
          this.alertSuccess('Los cambios han sido guardados.')
 
          // recargo los datos
          this.loadPersona(result.entity.id);
        } 
        catch(error){
          // Error          
          this.alertError(error)
        } 
        this.loading = false;
    },
    async generarContacto(telefono){
      if(this.selectedPersona)
      {
          var params = {
            width:500,
            personaId: this.selectedPersona.id,
            telefonoId: telefono.id,
            numTelefono: telefono.numero,
            perteneceAId: telefono.perteneceA.id,
            esTelefonoLaboral: telefono.esDeEmpleo,
            esCelular: telefono.esCelular,
            tipoGestionId:this.user.tipoGestionId,
            tareaId: this.selectedRow[0].tareaId,
            gestionAsignada:true,
            tipoGestionId:1
        };

        this.setActiveTask({task:'gestion-caso-puntual', props: params})
      }
        
    },
  }
}
</script>